import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';

const Data = styled(View)`
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #d0d0d0;
`;

const Label = styled(Text)`
  font-weight: 600;
`;

const Value = styled(Text)`
`;

const ATTRIBUTES = [
  { name: 'id', label: 'ID' },
  { name: 'createdAt', label: 'Time' },
  { name: 'url', label: 'URL' },
  { name: 'referrer', label: 'Referrer' },
  { name: 'ipAddress', label: 'IP Address' },
  { name: 'controller', label: 'Controller' },
  { name: 'action', label: 'Action' },
  { name: 'paramsId', label: 'Params ID' },
  { name: 'userAgent', label: 'User Agent' },
  { name: 'graphqlOperation', label: 'GraphQL Operation' },
  { name: 'graphqlVariables', label: 'GraphQL Variables' },
  { name: 'formattedParams', label: 'Params' },
];

const UserLog = ({ userLog }) => {
  return (
    <View>
      {ATTRIBUTES.map(({ name, label }) => (
        <Data>
          <Label>{label}</Label>
          <Value>{userLog[name]}</Value>
        </Data>
      ))}
    </View>
  );
};

export default UserLog;
